import React from 'react';
import BasedOnDatesLink from 'components/dashboard/common/BasedOnDatesLink';
import classNames from 'classnames';

class WidgetHeader extends React.Component {
  render() {
    const {headerStartDate, headerEndDate, location} = this.props;
    return (
      <header className="widget-head">
        <div className={classNames('title-and-dates', this.props.subheader && 'expand')}>
          <div className="widget-title">
            <h2>{this.props.title}</h2>
          </div>
          {this.props.subheader && <span className="subhead">{this.props.subheader}</span>}
          {this.props.showDates && (
            <BasedOnDatesLink
              startDate={headerStartDate}
              endDate={headerEndDate}
              location={location}
            />
          )}
        </div>
        <div className="controls">{this.props.children}</div>
      </header>
    );
  }
}

WidgetHeader.displayName = 'WidgetHeader';
export default WidgetHeader;
